import { useTranslation } from 'react-i18next';
import { PageLayout } from 'src/common/components/AppLayout/PageLayout';
import { TablePageTitle } from 'src/common/components/AppLayout/TablePage/TablePageTitle';

const ProductsPageTitle = () => {
  const { t } = useTranslation();

  return <TablePageTitle>{t('common.products')}</TablePageTitle>;
};

export const ProductPageLayout = ({ children }: { children: React.ReactNode }) => {
  return <PageLayout title={<ProductsPageTitle />}>{children}</PageLayout>;
};
